export default {
  allocationCompany: {},
  valuationApproach: null,
};
